import type { Prototype } from "../prototype-types";

export const quentinHsuPrototypes: Prototype[] = [
  {
    id: "compass-ai-chat-pdp-inline",
    name: "Compass AI Chat - PDP Inline",
    path: "/qh/compass-ai-chat-pdp-inline",
    description:
      "Quentin's variant of PDP AI Chat: full PDP with Ask Faire floating overlay. Same base as John's Feb 24 prototype.",
    owner: "Quentin",
    createdAt: "2026-02-24",
    lastUpdated: "2026-02-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/36e9438facbf92bffe51591fbe25f389ff8d76bcb03c87687d0556ca2e44d1ff.png",
    project: "Compass AI Chat",
    creationTool: "cursor",
  },
  {
    id: "qh-pdp-chat-v-2",
    name: "PDP Chat V2",
    path: "/qh/pdp-chat-v-2",
    description:
      "Production-parity prototype of PDP Chat (Ask Faire) — citations, hover cards, sources panel, ResearchedSection, streaming.",
    owner: "Quentin Hsu",
    createdAt: "2026-05-05",
    lastUpdated: "2026-05-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1637916f998b878f930dccff6f066d990ffd9a5c91684e37b8f22b525c19559d.png",
    creationTool: "claude-code",
  },
];
